export default {
  SET_CONFIG_DASHBOARD(state, value) {
    state.configDashboard = value;
  },
  SHOW_DEVELOPMENT_CHARTER(state, value) {
    state.isDevelopmentCharter = value;
  },
  SHOW_PROFILE_CARD(state, value) {
    state.isProfileCard = value;
  },
  SHOW_QUEST_CARD(state, value) {
    state.isQuestCard = value;
  },
  SHOW_USER_WALLET(state, value) {
    state.isUserWallet = value;
  },
  SHOW_QUEUE_CARD(state, value) {
    state.isQueueCard = value;
  },
  SHOW_TALENT_CARD(state, value) {
    state.isTalentCard = value;
  },
  SHOW_WIDGETS_CARD(state, value) {
    state.isWidgetCard = value;
  },
  SET_USER_WIDGETS(state, value) {
    state.userWidgets = value;
  },
  ADD_WIDGET(state, value) {
    state.userWidgets.push(value);
  },
  REMOVE_WIDGET(state, value) {
    state.userWidgets.splice(value, 1);
  },
  UPDATE_DASHBOARD_BLINKERS(state, value) {
    const { key, status } = value;
    state.blinkers[key] = status;
    localStorage.setItem("dashboardBlinkers", JSON.stringify(state.blinkers));
  },
};
